import { useAuthStore } from '@/stores/auth';

export const subscriptionValue = (productName: string) => {
	switch (productName) {
		case '대가 1인 정기 구독':
			return 1;
		case '대가 2인 정기 구독':
			return 2;
		case '대가 3인 정기 구독':
			return 3;
		case '대가 전체 정기 구독':
			return 0;
	}
};
export const getTextColorForBackground = (color: string) => {
	switch (color) {
		case '#CF0303':
			return '#FFFFFF';
		case '#E65500':
			return '#FFFFFF';
		case '#FFBB00':
			return '#222222';
		case '#0182F7':
			return '#FFFFFF';
		case '##289C0B':
			return '#FFFFFF';
		case '#8D0EFD':
			return '#FFFFFF';
		case '#DF3BBC':
			return '#FFFFFF';
		case '#64D1D9':
			return '#222222';
		case '#C9DF3B':
			return '#222222';
		case '#91523D':
			return '#FFFFFF';
		case '#7D862B':
			return '#FFFFFF';
		default:
			return '';
	}
};

export const checkId = () => {
	const authStore = useAuthStore();
	switch (authStore.getMemberNickname) {
		case 'herO':
			return true;
		case '임채욱':
			return true;
		case '제자계정':
			return true;
		case 'Hjj6068':
			return true;
		case '현명한투자자':
			return true;
		case '밸류업대가':
			return true;
		case 'lifeguard089':
			return true;
		case '네모':
			return true;
		case 'ehhdrud':
			return true;
		case 'ehhdruda':
			return true;
		case 'ehhdrud1':
			return true;
		case '데버테스터YH2':
			return true;
		case '홍홍홍':
			return true;
		case 'siasia1321':
			return true;
		case '박':
			return true;
		case 'twodragon2':
			return true;
		case '투드임':
			return true;
		case '투드투드1':
			return true;
		case '관리계정':
			return true;
		case '운영자':
			return true;
		case '귀여운매니저':
			return true;
		case 'Today리포트':
			return true;
		default:
			return false;
	}
};

export const handleChangeTopGainingCategory = (category: string) => {
	switch (category) {
		case '주간':
			return 'weekly';
		case '월간':
			return 'monthly';
		case '분기':
			return 'quarterly';
		case '연간':
			return 'annual';
		default:
			return 'weekly';
	}
};
